import { Controller } from 'stimulus';
import Cookies from 'js-cookie';
import { primeForPostLogin } from 'lib/helpers';

export default class CollectionSaveButtonController extends Controller {
  connect() {
    if (Cookies.get('add_collection_after_login')) {
      const resourceID = Cookies.get('add_collection_after_login');

      this.findAndClickCollectionSaveButton(resourceID);

      Cookies.remove('add_collection_after_login');
    }
  }

  findAndClickCollectionSaveButton(resourceID) {
    const resourceCollectionSaveButton = document.querySelector(`.resource-action-button--collect[data-resource-id="${resourceID}"]`);
    resourceCollectionSaveButton.click();
  }

  addToCollectionAfterLogin = () => {
    primeForPostLogin('add_collection_after_login', this.element.dataset.resourceId);
  }
}
